import React from 'react';
import PropTypes from 'prop-types';
import statuses from './statuses';
import Tooltip from '../tooltip';
import I18n from '../i18n';

export default function NavItemStatusIndicator(props) {
  const {status, message, messageOpts} = props;

  if (status === statuses.ok) {
    return <></>;
  } else if (message) {
    const translatedMessage = I18n.t(message, messageOpts);
    return (
      <Tooltip placement="top" message={translatedMessage}>
        <div className={`status ${status}`}></div>
      </Tooltip>
    );
  }
  return <div className={`status ${status}`}></div>;
}

NavItemStatusIndicator.propTypes = {
  /** The status to indicate. */
  status: PropTypes.oneOf(['ok', 'warn', 'error']).isRequired,
  /** The message to show as a tooltip as an i18n key. */
  message: PropTypes.string,
  /** Optionally, an object to pass as the 2nd argument to i18n.t() for formatting the message. */
  messageOpts: PropTypes.object,
};
